import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../ApiUrl/ApiUrl";
import { useLocation } from "react-router-dom";

const Filter = ({ getCheckboxProps }) => {
  const location = useLocation();
  const [categoriess, setCategoriess] = useState([]);
  const params = new URLSearchParams(location.search);
  const subcname = params.get("maincat");

  useEffect(() => {
    const maincat = localStorage.getItem("maincatname");
    const categoryName = subcname ? subcname : maincat || "Books";

    fetch(`${apiUrl}/public/getsubCatByCatName?cname=${encodeURIComponent(categoryName.toUpperCase())}`)
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch categories");
        return response.json();
      })
      .then((data) => {
        setCategoriess(
          data.map((category) => ({
            ...category,
            subcatname: category.subcatname.toUpperCase(),
          }))
        );
      })
      .catch((error) => console.error("Error fetching categories:", error));
  }, [location.search, subcname]);

  const handleCategoryChange = (subcatname) => {
    localStorage.setItem("subcatname", subcatname);
    window.location.reload();
  };

  const currentSubcat = localStorage.getItem("subcatname") || "";

  return (
    <Accordion defaultIndex={[0]} allowMultiple>
      <AccordionItem border="none">
        <h2>
          <AccordionButton px="2" py="3" rounded="lg" _hover={{ bg: "gray.50" }}>
            <Box flex="1" textAlign="left" fontWeight="700" fontSize="13px" color="gray.800" textTransform="uppercase" letterSpacing="0.4px">
              Subcategories ({categoriess.length})
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel px="2" py="2" maxH="380px" overflowY="auto">
          <RadioGroup value={currentSubcat}>
            <Stack spacing="2">
              {categoriess.map((category, index) => {
                const isSelected = category.subcatname === currentSubcat;
                return (
                  <Box
                    key={index}
                    p="2"
                    rounded="lg"
                    bg={isSelected ? "blue.50" : "transparent"}
                    _hover={{ bg: isSelected ? "blue.50" : "gray.50" }}
                    cursor="pointer"
                    transition="background 0.15s"
                    onClick={() => handleCategoryChange(category.subcatname)}
                  >
                    <Radio
                      size="sm"
                      value={category.subcatname}
                      colorScheme="blue"
                      isChecked={isSelected}
                    >
                      <Text
                        fontSize="12.5px"
                        fontWeight={isSelected ? "700" : "500"}
                        color={isSelected ? "#1D4ED8" : "gray.700"}
                        lineHeight="1.3"
                      >
                        {category.subcatname}
                      </Text>
                    </Radio>
                  </Box>
                );
              })}
            </Stack>
          </RadioGroup>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default Filter;